import { AnnouncementDetails } from './announcement-detail-model';

import { Serializable } from '@admin/core/models/serializable';
import { AnnouncementDistributionChannel } from '@admin/announcements/shared/models/announcement-distribution-channel';
export class AnnouncementModel implements Serializable<AnnouncementModel> {
  fromObject(obj: any): AnnouncementModel {
    Object.assign(this, obj);
    this.announcementDistributionChannels = [];

    if (
      obj.announcementDistributionChannels &&
      obj.announcementDistributionChannels.length &&
      obj.announcementDistributionChannels.length > 0
    ) {
      obj.announcementDistributionChannels.forEach((a) => {
        let t = new AnnouncementDistributionChannel();
        t = t.fromObject(a);
        this.announcementDistributionChannels.push(t);
      });
    }
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public announcementId: number;
  public customerName: string;
  public title: string;
  public publisher: string;
  public publishDate: Date;
  public deadlineDate: Date;
  public lastChangeDate: Date;
  public renewalDate: Date;
  public priorityExpireDate: Date;
  public announcementStatusId: number;
  public status: string;
  public viewCount: number;
  public applicationCount: number;
  public announcementDistributionChannels: AnnouncementDistributionChannel[];
  public announcementDetails: AnnouncementDetails;
  public applicationMethodId: number;
  public hasCaptureCv: boolean;
  public scheduledRenewalDates: Date[];
  public actualRenewalDates: Date[];
  public drivingLicenses: any[];
  public requiredLanguages: any[];

  public workExperienceFrom: number;
  public workExperienceTo: number;

  constructor() {
    this.announcementDistributionChannels = [];
    this.scheduledRenewalDates = [];
    this.actualRenewalDates = [];
  }
}
